import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { globalStore } from '../GlobalStore';
import { buildSharePageUrl } from '../utils/SharePageUrl';
import { ImagePreview } from './ImagePreview';

const BUSINESS_LICENSE_URL =
  'https://yuanling-new.oss-cn-shanghai.aliyuncs.com/frontend-static/02/021c3db0a0276e6977d771d30abbe9addc5a72329f83d8d9be0b2fa3a4baebc4.jpg';

const Footer: React.FC = observer(() => {
  const [licensePreviewVisible, setLicensePreviewVisible] = useState(false);
  const buyerAppQrCodeUrl = globalStore.buyerAppQrCodeUrl;
  const contactQrUrl = globalStore.csContact?.wechatImageUrl;
  const tradingRulesUrl = buildSharePageUrl(globalStore.basicConfigs, 'trading-rules');
  const userAgreementUrl = buildSharePageUrl(globalStore.basicConfigs, 'user-agreement');
  const policyStatementUrl = buildSharePageUrl(globalStore.basicConfigs, 'policy-statement');
  const personalInfoProtectUrl = buildSharePageUrl(
    globalStore.basicConfigs,
    'personal-information-protect'
  );
  const footerStyle: React.CSSProperties = {
    backgroundColor: '#012234',
    width: '100%',
    padding: '40px 0',
    paddingBottom: '100px',
    margin: 0,
    color: 'white'
  };

  const footerContentStyle: React.CSSProperties = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '0 20px',
    paddingBottom: '20px'
  };

  const footerSectionStyle: React.CSSProperties = {
    flex: 1,
    textAlign: 'center' as const
  };

  const leftSectionStyle: React.CSSProperties = {
    ...footerSectionStyle,
    textAlign: 'left' as const
  };

  const rightSectionStyle: React.CSSProperties = {
    ...footerSectionStyle,
    textAlign: 'right' as const
  };

  const footerTitleStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '20px',
    color: 'white'
  };

  const footerLinksStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  };

  const footerLinkStyle: React.CSSProperties = {
    color: '#cccccc',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.3s ease',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left' as const
  };

  const footerQrStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center'
  };

  const rightQrStyle: React.CSSProperties = {
    ...footerQrStyle,
    justifyContent: 'flex-end'
  };

  const qrCodeStyle: React.CSSProperties = {
    width: '120px',
    height: '120px',
    borderRadius: '8px',
    backgroundColor: 'white'
  };

  const dividerStyle: React.CSSProperties = {
    maxWidth: '1170px',
    marginInline: 'auto',
    marginTop: '20px',
    marginBottom: '15px',
    height: '1px',
    backgroundColor: '#333333'
  };

  const bottomInfoStyle: React.CSSProperties = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const logoStyle: React.CSSProperties = {
    height: '20px',
    width: 'auto'
  };

  const companyInfoStyle: React.CSSProperties = {
    color: '#cccccc',
    fontSize: '14px',
    lineHeight: '1.4',
    textAlign: 'right' as const
  };

  return (
    <footer style={footerStyle}>
      <div style={footerContentStyle}>
        <div style={leftSectionStyle}>
          <h3 style={footerTitleStyle}>协议与规则</h3>
          <div style={footerLinksStyle}>
            <a href={tradingRulesUrl} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>平台交易规则</a>
            <a href={userAgreementUrl} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>平台用户协议</a>
            <a href={policyStatementUrl} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>法律声明及隐私权政策</a>
            <a href={personalInfoProtectUrl} target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>个人信息保护政策</a>
            <button
              type="button"
              onClick={() => setLicensePreviewVisible(true)}
              style={footerLinkStyle}
            >
              营业执照
            </button>
          </div>
        </div>

        <div style={leftSectionStyle}>
          <h3 style={footerTitleStyle}>圆领百科</h3>
          <div style={footerLinksStyle}>
            <a href="/baike/what-is-yuanling.html" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>认识圆领</a>
            <a href="/baike/remote-vision.html" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>远程工作愿景</a>
            <a href="/baike/for-enterprises.html" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>企业用工与工种</a>
            <a href="/baike/temporary-consult.html" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>临时咨询指南</a>
            <a href="/baike/faq.html" target="_blank" rel="noopener noreferrer" style={footerLinkStyle}>交易保障问答</a>
          </div>
        </div>
        
        <div style={footerSectionStyle}>
          <h3 style={footerTitleStyle}>联系我们</h3>
          <div style={footerQrStyle}>
            {contactQrUrl ? (
              <img 
                src={contactQrUrl} 
                alt="联系我们二维码" 
                style={qrCodeStyle}
              />
            ) : null}
          </div>
        </div>
        
        <div style={rightSectionStyle}>
          <h3 style={footerTitleStyle}>下载圆领APP</h3>
          <div style={rightQrStyle}>
            {buyerAppQrCodeUrl ? (
              <img 
                src={buyerAppQrCodeUrl} 
                alt="圆领APP二维码" 
                style={qrCodeStyle}
              />
            ) : null}
          </div>
        </div>
      </div>
      
      <div style={dividerStyle}></div>
      
      <div style={bottomInfoStyle}>
        <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}> 
            <img 
              src="/logo_for_deep_color.svg" 
              alt="Superthem Logo" 
              style={logoStyle}
            />
            <span style={{fontSize: '14px', fontWeight: 600, color: 'rgb(255, 255, 255)'}}>圆领</span>
        </div>
        
        <div style={companyInfoStyle}>
          上海魔法向量网络有限公司 | 浦东新区新场镇新环西路860号3幢一层104室 | ©2023-现在 | 备案号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{ color: '#cccccc', textDecoration: 'none' }}>沪ICP备2023014111号-1</a> | 沪公网安备31011502401159号
        </div>
      </div>

      <ImagePreview
        visible={licensePreviewVisible}
        onClose={() => setLicensePreviewVisible(false)}
        imagePath={BUSINESS_LICENSE_URL}
        imageMaxHeight="75vh"
      />
    </footer>
  );
});

export default Footer;
